<div class="flex h-full w-full items-center justify-between gap-3 px-4 py-2">
  <div class="flex min-w-0 flex-1 items-center">
    <button
      type="button"
      class="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-gray-700 hover:bg-gray-100 md:hidden"
      (click)="mobileNav.toggle()"
      [attr.aria-expanded]="mobileNav.isOpen()"
      aria-controls="dashboard-mobile-nav"
      [attr.aria-label]="mobileNav.isOpen() ? 'Fermer le menu' : 'Ouvrir le menu'"
    >
      <span class="material-symbols-outlined text-2xl leading-none">{{
        mobileNav.isOpen() ? 'close' : 'menu'
      }}</span>
    </button>
  </div>
  <div class="flex shrink-0 justify-end">
    @if (isInitialized()) {
      <app-header-user
        [fullName]="user$().fullName"
        [email]="user$().email"
        [isAdmin]="!!user$().admin"
        [settingsUrl]="settingsUrl()"
      ></app-header-user>
    }
  </div>
</div>
